/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LOCALE_ID, NgModule } from '@angular/core';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbLayoutModule,
} from '@nebular/theme';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuard } from './@core/auth/auth.guard';
import { APP_BASE_HREF } from '@angular/common';
import { NbRoleProvider, NbSecurityModule } from '@nebular/security';
import { UsuarioService } from './pages/admin/services/usuario.service';
import { AprobacionSellOutService } from './pages/admin/services/aprobacion-sell-out.service';
import { FactorConversionBdService } from './pages/admin/services/factor-conversion-bd.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { DistributorService } from './pages/admin/services/distributor.service';
import { BusinessUnitService } from './pages/dashboard/services/business-unit.service';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { ContactoService } from './pages/admin/services/contacto.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PuestoService } from './pages/dashboard/services/puesto.service';
import { IntegranteService } from './pages/dashboard/services/integrante.service';
import { ArticuloService } from './pages/admin/services/articulo.service';
import es from '@angular/common/locales/es';
import pt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
registerLocaleData(es);
registerLocaleData(pt);
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { CdkTableModule } from '@angular/cdk/table';
import { environment as env } from '../environments/environment';
import { UserService } from './@core/services/userService/user.service';
import { LandingComponent } from './landing/landing.component';
import { ActivacionUsuarioComponent } from './pages/activacion-usuario/activacion-usuario.component';
import { TranslocoRootModule } from './transloco-root.module';
import { LangInterceptor } from './@core/services/httpInterceptor/lang-interceptor';
import { HttpCacheableService } from './@core/services/cachingService/http-cacheable.service';
import { CacheService } from './@core/services/cachingService/cache.service';
import { CriteriosClasificacionService } from './pages/admin/services/criterios-clasificacion.service';
import { CategoriaArticuloService } from './pages/admin/services/categoria-articulo';
import { HttpInterceptorService } from './@core/services/httpInterceptor/http-interceptor.service';
import { ManualService } from './pages/admin/services/manual.service';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { PreguntasFrecuentesService } from './pages/admin/services/preguntas-frecuentes.service';
import { CategoriaPreguntasFrecuentesService } from './pages/admin/services/categoria-preguntas-frequentes.service';
import { NotificacoesService } from './pages/admin/services/notificacoes.service';
import { CargaObjetivoAdministradorService } from './pages/admin/services/carga-objetivo-Administrador.service';

@NgModule({
  declarations: [AppComponent, LandingComponent, ActivacionUsuarioComponent],
  imports: [
    BrowserModule,
    MatTableModule,
    MatSortModule,
    CdkTableModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbDatepickerModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbLayoutModule,
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    NbSecurityModule.forRoot({
      accessControl: {
        'Administrador': {
          view: ['admin-module', 'dashboard'],
        },
        'Super Gerente': {
          view: ['admin-module', 'dashboard'],
        },
        'Gerente': {
          view: ['admin-module', 'dashboard'],
        },
        'Channel Referente': {
          view: ['admin-module', 'perfil', 'dashboard'],
        },
        'Channel Multi países': {
          view: ['admin-module', 'perfil', 'dashboard'],
        },
        'Distribuidor': {
          view: ['perfil', 'dashboard'],
        },
      },
    }),
    MatAutocompleteModule,
    MatOptionModule,
    MatInputModule,
    MatSelectModule,
    MatChipsModule,
    MatTooltipModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    TranslocoRootModule,
    ThemeModule,
    AngularEditorModule
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: NbAuthJWTInterceptor,
    //   multi: true,
    // },
    // {
    //   provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER, useValue: function (req: HttpRequest<any>) {
    //     return req.url === environment.apiEndPoint + 'api/token/refresh';
    //   },
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LangInterceptor,
      multi: true,
    },


    { provide: LOCALE_ID, useValue: 'es-ES' },
    { provide: NbRoleProvider, useClass: UserService },
    AuthGuard,
    UsuarioService,
    DistributorService,
    AprobacionSellOutService,
    FactorConversionBdService,
    ManualService,
    CriteriosClasificacionService,
    BusinessUnitService,
    ContactoService,
    PuestoService,
    IntegranteService,
    ArticuloService,
    CategoriaArticuloService,
    HttpCacheableService,
    CacheService,
    CategoriaPreguntasFrecuentesService,
    PreguntasFrecuentesService,
    NotificacoesService,
    CargaObjetivoAdministradorService
  ],
})
export class AppModule {
}
